// ADR-133 D11: status of an unmapped title (radar-api UNMAPPED_TITLE_STATUSES),
// with a fallback for responses without it.
export const TITLE_STATUSES = Object.freeze({
  NOT_MAPPED: 'NOT_MAPPED',
  MAPPED_SINCE: 'MAPPED_SINCE',
  MAPPED_NOT_APPLIED: 'MAPPED_NOT_APPLIED',
});

export const titleStatusOf = (entry) => entry?.status
  || (entry?.coveredByExactMapping ? TITLE_STATUSES.MAPPED_SINCE : TITLE_STATUSES.NOT_MAPPED);

/** Still needs someone's attention: not mapped, or mapped but not applied by the run. */
export const needsAttention = (entry) => titleStatusOf(entry) !== TITLE_STATUSES.MAPPED_SINCE;
